import React from 'react'
import ReactDOM from 'react-dom'

// Config
import * as config from './config'

// Routes
import { route, routes } from './routes'

// Styles 
import './index.scss'

// Components
import Navigation from './modules/navigation'

// Providers
import { NavigationProvider } from './modules/navigation'
import { AuthProvider } from './modules/auth'
import { ModalProvider } from './modules/modal'

// Language
import './i18n'

async function App() {
  
  @AuthProvider()
  @NavigationProvider({ routes, history: [route] })
  @ModalProvider
  class Root extends React.Component {

    render() {
      return (
        <Navigation />
      )
    }

  }

  return Root
}

(async function() {
  const Root = await App()

  const domContainer = document.querySelector(config.app.container)
  if(domContainer) ReactDOM.render(<Root />, domContainer)
})()
